// import { Box, Typography, Grid, Paper, CardContent, useTheme } from "@mui/material";
// import CountryMap from "./CountryMap.jsx";
// import StateMap from "../../../components/leaftletMapComponent/StateMap";
// import React, { useState, useEffect } from "react";
// import { motion } from "framer-motion";
// import CountUpAnimation from "../../../components/common/CountUpAnimation.jsx";

// const BJSMapSection = ({ data }) => {
//   const [view, setView] = useState("country"); // "country" | "state"
//   const [selectedState, setSelectedState] = useState("maharashtra");
//   const theme = useTheme();
//   const MotionBox = motion(Box);

//   const pillStyle = {
//     px: 2,
//     py: 0.7,
//     borderRadius: "999px",
//     background: theme.palette.secondary.pillColor,
//     color: "#fff",
//     fontWeight: 600,
//     fontSize: "0.85rem",
//   };

//   const StatCard = ({ value, label }) => (
//     <Box textAlign="center">
//       <Box
//         sx={{
//           p: 4,
//           borderRadius: 3,
//           border: "3px solid #cbb6f5",
//         }}
//       >
//         <Typography variant="h3" fontWeight={800} color={theme.palette.secondary.pillColor}>
//           {value}
//         </Typography>
//       </Box>

//       <Typography mt={1} variant="h5" fontWeight={600}>
//         {label}
//       </Typography>
//     </Box>
//   );

//   const stateCount = data?.totalStates || "0"
//   // const districtCount = data?.totalDistricts || "0"
//     const districtCount =  "171"

//   const chapterCount = data?.totalChapter || "0"


//   return (
//     <Box
//       sx={{
//         backgroundColor: theme.palette.background.paper,
//         display: "flex",
//         justifyContent: "center",
//       }}
//     >
//       <Box
//         sx={{
//           width: "100%",
//           maxWidth: "1200px",
//           margin: { xs: 0, md: "0 50px" },
//           // backgroundColor: theme.palette.background.slate,
//           borderRadius: 3,
//           p: { xs: 2, sm: 3, md: 4 },
//           display: "flex",
//           flexDirection: { xs: "column", sm: "column", md: "row" },
//           gap: 3,
//           alignItems: "stretch",
//         }}
//       >

//         {/* LEFT SIDE — YOUR NEW UI */}
//         <Box sx={{ flex: 0.8,  p: { xs: 2, sm: 3, md: 4, lg: 5 } }}>
//           <Box
//             sx={{
//               textAlign: "center",
//               width: "100%",
//               // maxWidth: "fit-content",   //  shrink here
//               maxWidth: "700px",   //  shrink here
//               margin: "0 auto"     // center it
//             }}
//           >
//             <Typography fontWeight={700} mb={4} sx={{fontSize: {xs:"18px",sm:"27px", md:"36px"}}}>
//               Nationwide Presence
//             </Typography>

//             <Grid container spacing={2}>
//               {/* Card 1 */}
//               <Grid item xs={12}>
//                 <Paper sx={{ p: 2, borderRadius: 3, background: theme.palette.secondary.LPMapSection }}>
//                   <Typography mb={2} fontWeight={700}>
//                     Across the nation we have
//                   </Typography>

//                   <Box
//                     display="flex"
//                     flexWrap={{ xs: "wrap", md: "nowrap" }}
//                     justifyContent="center"
//                     alignItems="center"
//                     gap={1}
//                   >
//                     {["State", "Regions", "Districts", "Chapters"].map((item, i) => (
//                       <React.Fragment key={item}>
//                         <Box sx={pillStyle}>{item}</Box>
//                         {i !== 3 && <Typography>»</Typography>}
//                       </React.Fragment>
//                     ))}
//                   </Box>
//                 </Paper>
//               </Grid>

//               {/* Card 2 */}
//               <Grid item xs={12}>
//                 <Paper sx={{ p: 2, borderRadius: 3, background: theme.palette.secondary.LPMapSection, width: "100%" }}>
//                   <Typography mb={2} fontWeight={700}>
//                     BJS Volunteer Network Hierarchy
//                   </Typography>

//                   <Box
//                     display="flex"
//                     flexWrap={{ xs: "wrap", md: "nowrap" }}
//                     justifyContent="center"
//                     alignItems="center"
//                     gap={1}
//                   >
//                     {["NEC", "SEC", "REC", "DEC", "Chapters"].map((item, i) => (
//                       <React.Fragment key={item}>
//                         <Box sx={pillStyle}>{item}</Box>
//                         {i !== 4 && <Typography>»</Typography>}
//                       </React.Fragment>
//                     ))}
//                   </Box>
//                 </Paper>
//               </Grid>
//             </Grid>

//             {/* STATS */}

//             <Grid container spacing={1} mt={1}>
//               <Grid item xs={12} sm={4}>
//                 <StatCard value={stateCount + "+" || "10+"} label="States" />
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <StatCard value={districtCount + "+" || "100+"} label="Districts" />
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <StatCard value={chapterCount + "+" || "300+"} label="Chapters" />
//               </Grid>
//             </Grid>
//           </Box>
//         </Box>

//         {/* RIGHT SIDE — MAP (FROM OLD CODE) */}
//         <Box
//           sx={{
//             flex: 1.2,
//             minHeight: { xs: "400px", md: "700px" },
//             minWidth: 0,
//             alignContent: "center",
//             display: "flex",
//             alignItems: "stretch",
//             justifyContent: "center",
//           }}
//         >
//           <Box sx={{ width: "100%", height: "100%" }}>
//           {view === "country" && (
//             <CountryMap
//               enableCustomizer={true}
//               onStateClick={(stateName) => {
//                 setSelectedState(stateName);
//                 setView("state");
//               }}
//               onCountryClick={() => {
//                 setSelectedState(null);
//                 setView("country");
//               }}
//             />
//           )}

//           {view === "state" && (
//             <StateMap
//               name={selectedState}
//               onBack={() => {
//                 setSelectedState(null);
//                 setView("country");
//               }}
//             />
//           )}
//           </Box>
//         </Box>

//       </Box>
//     </Box>
//   )
// };

// export default BJSMapSection;











import { Box, Typography, Grid, Paper, useTheme } from "@mui/material";
import CountryMap from "./CountryMap.jsx";
import StateMap from "../../../components/leaftletMapComponent/StateMap";
import React, { useState } from "react";
import CountUpAnimation from "../../../components/common/CountUpAnimation.jsx";

const BJSMapSection = ({ data }) => {
  const [view, setView] = useState("country");
  const [selectedState, setSelectedState] = useState("maharashtra");
  const theme = useTheme();

  const pillStyle = {
    px: { xs: 1.2, sm: 2 },
    py: 0.7,
    borderRadius: "999px",
    background: "#FF894A",
    color: "#fff",
    fontWeight: 600,
    fontSize: "0.75rem", // slightly smaller for xs
    whiteSpace: "nowrap",
    // flexShrink: 0,
  };

  const StatCard = ({ value, label }) => (
    <Box textAlign="center">
      <Box
        sx={{
          p: { xs: 1, sm: 2, md: 3 },
          borderRadius: 3,
          border: "3px solid #cbb6f5",
          // aspectRatio: {xs:"1 / 0.5", lg:"1/0.8"},
          height: { lg: "100px" },
          minWidth: { xs: "90px", sm: "auto" },
          textAlign: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "x-large !important", sm: "x-large" },
            fontWeight: 1000,
            color: "black",
          }}
        >
          {value}
        </Typography>
      </Box>

      <Typography
        mt={1}
        sx={{
          fontSize: { xs: "11px", sm: "18px" },
          fontWeight: "bold",
        }}
      >
        {label}
      </Typography>
    </Box>
  );

  const stateCount = data?.totalStates || "12";
  const districtCount = "170";
  const chapterCount = data?.totalChapter || "Loading";

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1200px",
          margin: { xs: 0, md: "0 50px" },
          borderRadius: 3,
          p: { xs: 1.5, sm: 3, md: 4 }, // tighter xs
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          gap: 3,
        }}
      >
        {/* LEFT */}
        <Box sx={{ flex: 0.8, p: { xs: 1, sm: 3, md: 4 }, display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              textAlign: "center",
              maxWidth: { xs: "100%", sm: "600px", md: "700px" },
              margin: { xs: "0", sm: "0 auto" },
            }}
          >
            <Typography
              fontWeight={700}
              mb={3}
              variant="h1"
              sx={{
                fontSize: { xs: "18px", sm: "27px", md: "36px" },
                color: theme.palette.primary.LPtitles,
              }}
            >
              Nationwide Presence
            </Typography>

            <Grid container columnSpacing={0} rowSpacing={2}>
              {/* CARD 1 */}
              <Grid item xs={12}>
                <Paper sx={{
                  p: 2,
                  borderRadius: 3,
                  background: "#FFEDE5",
                  display: { xs: "flex" },
                  textAlign: { xs: "center" },
                  flexDirection: { xs: "column" },
                  alignItems: { xs: "center" },
                }}>
                  <Typography mb={2} fontWeight={700}>
                    Across the nation we have
                  </Typography>

                  <Box
                    // sx={{
                    //   display: "flex",
                    //   gap: { xs: 0.2, sm: 1, md: 1.5 },
                    //   alignContent: { xs: "center", sm: "center" },
                    //   overflowX: { xs: "auto", md: "visible" },
                    //   // alignSelf: {
                    //   //   xs: "center",
                    //   // },
                    //   flexWrap: "nowrap",
                    //   justifyContent: {
                    //     xs: "flex-start",
                    //     sm: "center"
                    //   },
                    //   "@media(min-width:400px)": {
                    //     justifyContent: "center"
                    //   },

                    //   px: 0.2,
                    // }}

                    sx={{
                      display: "flex",
                      width:"100%",
                      gap: { xs: 0.2, sm: 1, md: 1.5 },
                      alignContent: { xs: "center", sm: "center" },
                      overflowX: { xs: "auto", md: "visible" },
                      flexWrap: { xs: "nowrap" },
                      justifyContent: {
                        xs: "flex-start",
                        sm: "center"
                      },
                      "@media(min-width:400px)": {
                        justifyContent: "center"
                      },
                      px: 0.2,
                    }}

                  >
                    <Box sx={{display:"flex", flexDirection:"row", overflowX:"scroll", gap:"4px"}}>
                      {["State", "Regions", "Districts", "Chapters"].map((item, i) => (
                        <React.Fragment key={item}>
                          <Box sx={pillStyle}>{item}</Box>
                          {i !== 3 && <Typography>»</Typography>}
                        </React.Fragment>
                      ))}
                    </Box>
                  </Box>
                </Paper>
              </Grid>

              {/* CARD 2 */}
              <Grid item xs={12}>
                <Paper sx={{
                  p: 2,
                  borderRadius: 3,
                  background: "#FFF5E5",
                  display: { sm: "flex" },
                  textAlign: { sm: "center" },
                  flexDirection: { sm: "column" },
                  alignItems: { sm: "center" },
                }}>
                  <Typography mb={2} fontWeight={700}>
                    BJS Volunteer Network Hierarchy
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      gap: { xs: 0.2, sm: 1, md: 1.5 },
                      alignContent: { xs: "center", sm: "center" },
                      overflowX: { xs: "auto", md: "visible" },
                      flexWrap: { xs: "nowrap" },
                      justifyContent: {
                        xs: "flex-start",
                        sm: "center"
                      },
                      "@media(min-width:400px)": {
                        justifyContent: "center"
                      },
                      px: 0.2,
                    }}
                  >
                    {["NEC", "SEC", "REC", "DEC", "Chapters"].map((item, i) => (
                      <React.Fragment key={item}>
                        <Box sx={{
                          px: 2,
                          py: 0.7,
                          borderRadius: "999px",
                          background: "#FDAD02",
                          color: "#fff",
                          fontWeight: 600,
                          fontSize: "0.75rem", // slightly smaller for xs
                          whiteSpace: "nowrap",
                        }}>
                          {item}</Box>
                        {i !== 4 && <Typography>»</Typography>}
                      </React.Fragment>
                    ))}
                  </Box>
                </Paper>
              </Grid>
            </Grid>

            {/* STATS */}
            <Grid
              container
              spacing={0.5}
              mt={1}
              sx={{
                flexWrap: { sm: "wrap" },
                overflowX: { sm: "visible" },
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",

                // smaller controlled gap
                gap: { xs: "10px", sm: "15px", md: "15px" },
              }}
            >
              <Grid
                item
                sx={{
                  width: {
                    xs: "30%",
                    sm: "31%",
                  },
                }}
              >
                <StatCard value={stateCount + "+"} label="States" />
              </Grid>
              <Grid
                item
                sx={{
                  width: {
                    xs: "30%",
                    sm: "31%",
                  },
                }}
              >
                <StatCard value={districtCount + "+"} label="Districts" />
              </Grid>
              <Grid
                item
                sx={{
                  width: {
                    xs: "30%",
                    sm: "31%",
                  },
                }}
              >
                <StatCard value={chapterCount + "+"} label="Chapters" />
              </Grid>
            </Grid>
          </Box>
        </Box>

        {/* RIGHT MAP */}
        <Box
          sx={{
            flex: 1.2,
            minHeight: { xs: "480px", sm: "400px", md: "500px" },
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box sx={{ width: "100%", height: "100%", alignContent: "center" }}>
            {view === "country" && (
              <CountryMap
                enableCustomizer={true}
                onStateClick={(stateName) => {
                  setSelectedState(stateName);
                  setView("state");
                }}
                onCountryClick={() => {
                  setSelectedState(null);
                  setView("country");
                }}
              />
            )}

            {view === "state" && (
              <StateMap
                name={selectedState}
                onBack={() => {
                  setSelectedState(null);
                  setView("country");
                }}
              />
            )}
          </Box>
        </Box>
      </Box>
    </Box >
  );
};

export default BJSMapSection;